const axios = require('axios');

export function getZipInfo(zipcode){
    return axios.get(`https://deelay.me/1000/https://api.zippopotam.us/de/${zipcode}`);
}
export function getStatus(){
    return axios.get('http://localhost:3001/api/v1/status');
}